import FederationConfig from "./federationConfig";
import i18next from "i18next";

export default function () {
  if (process.env.VUE_APP_GOOGLE_MAPS_API_KEY) {
    window.googleMapCallback = function () {
      // do nothing really, google wants callback
    };
    var script = document.createElement("script");
    const props = new URLSearchParams();
    props.set("callback", "googleMapCallback");
    props.set("key", process.env.VUE_APP_GOOGLE_MAPS_API_KEY);
    props.set("language", i18next.language);
    props.set("region", FederationConfig.countryCode);
    props.set("libraries", "places,marker");
    props.set("loading", "async");
    props.set("v", "quarterly");

    script.src = `https://maps.googleapis.com/maps/api/js?` + props.toString();
    script.defer = true;
    script.async = true;

    document.head.append(script);
  }
}
